import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import UsedSession from "./UsedSession";
import SessionActivityLog from "../../components/home/SessionActivityLog";
import { Metrics } from "../../theme/";
import { Sessions } from "../../util/appointments";
import { isAlive } from "../../util/index";
import Colors, { StaticColor } from "../../theme/Colors";
import Moment from "moment";

class SessionPanels extends React.Component {
	bakeAppointments = [];
	allLength = 0;
	constructor(props, context) {
		super(props);
		this.initial(props, context);
	}
	componentWillReceiveProps(props, context) {
		this.initial(props, context);
	}
	initial(props, context) {
		const { showSessions, filterDate } = props;
		const { appointments } = context;
		this.bakeAppointments = [];
		this.allLength = 0;
		const filterFormat = "YYYY-MM-DD";
		if (isAlive(appointments)) {
			let rangeDate = null;
			if (isAlive(filterDate)) {
				rangeDate = [
					Moment(filterDate[0], filterFormat).startOf('day'),
					Moment(filterDate[1], filterFormat).endOf('day')
				];
			}
			for (let i = 0; i < appointments.length; i += 1) {
				const { due, status } = appointments[i];
				if (rangeDate !== null) {
					if (Moment(due, "X").isBetween(rangeDate[0], rangeDate[1], undefined, '[]')) {
						this.allLength += 1;
						if (showSessions.indexOf(status) !== -1) {
							this.bakeAppointments.push(appointments[i]);
						}
					}
				} else {
					this.allLength += 1;
					if (showSessions.indexOf(status) !== -1) {
						this.bakeAppointments.push(appointments[i]);
					}
				}
			}
		}
	}
	render() {
		const { showSessions } = this.props;
		const {
			organization: { wallet_time = 100, max_wallet_time = 100 }
		} = this.context;
		return (
			<Row gutter={Metrics.button.bigSpaceMargin}>
				<Col md={24} lg={24} xl={10}>
					<UsedSession
						appointments={this.bakeAppointments}
						allLength={this.allLength}
						showSessions={showSessions}
						sessionValue={max_wallet_time - wallet_time}
						maxSession={max_wallet_time}
					/>
				</Col>
				<Col md={24} lg={24} xl={14}>
					<SessionActivityLog
						appointments={this.bakeAppointments}
						showSessions={showSessions}
					/>
				</Col>
			</Row>
		);
	}
}
SessionPanels.contextTypes = {
	organization: PropTypes.object,
	appointments: PropTypes.array
};
SessionPanels.defaultProps = {
	showSessions: Object.values(Sessions).slice(1),
	filterDate: null
};
export default SessionPanels;



// WEBPACK FOOTER //
// ./src/containers/HomePanels/SessionPanels.js